import React, { useEffect, useState } from "react";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import axios from "axios";
import { base_url } from "./components/AgentWhitelist";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [totalCustomer, setTotalCustomer] = useState(0);
  const [totalagent, setTotalagent] = useState(0);
  const [activeCustomer, setActiveCustomer] = useState(0);

  const [bets, setBets] = useState(0);
  const [wins, setWins] = useState(0);
  const [ggr, setGgr] = useState(0);
  const [panelWin, setPanelWin] = useState(0);
  const [ggrpercent, setGgrpercent] = useState(0);

  const navigate = useNavigate();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  /* ================= DASHBOARD COUNTS ================= */
  const dashboardCounts = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const res = await axios.get(`${base_url}/api/admin/dashdynamic`, {
        headers: { Authorization: auth },
      });

      const active = res.data.customers.filter(
        (c) => c.status === "Active"
      );

      setTotalCustomer(res.data.customers.length);
      setTotalagent(res.data.agents.length);
      setActiveCustomer(active.length);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= GGR PERCENT ================= */
  const userinfo = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const res = await axios.get(`${base_url}/api/webapi/userinfo`, {
        headers: { Authorization: auth },
      });
      setGgrpercent(res.data.user.ggr || 0);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= CASINO SUMMARY ================= */
  const casinoSummary = async () => {
    try {
      const auth = localStorage.getItem("admin");

      const res = await axios.get(
        `${base_url}/api/webapi/casinoHistory`,
        { headers: { Authorization: auth } }
      );

      if (res.data.success) {
        const data = res.data.result;

        const totals = data.reduce(
          (acc, row) => {
            const bet = Number(row.bet_amount) || 0;
            const win = Number(row.win_amount) || 0;
            const ggr = Number(row.ggr) || 0;

            acc.bets += bet;
            acc.wins += win;
            acc.ggr += ggr;

            if (row.round_status === "LOSS") {
              acc.panelWin += bet;
            }

            return acc;
          },
          { bets: 0, wins: 0, ggr: 0, panelWin: 0 }
        );

        setBets(totals.bets);
        setWins(totals.wins);
        setGgr(totals.ggr);
        setPanelWin(totals.panelWin);
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= EFFECTS ================= */
  useEffect(() => {
    dashboardCounts();
    userinfo();
    casinoSummary();
  }, []);

  useEffect(() => {
    const resize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div className="content-wrapper p-3">
        <h1 className="mb-4">Dashboard</h1>

        <div className="metrics-grid">
          <div className="metric-card" onClick={() => navigate("/admin/casinoHistory")}>
            <h3>Total Bets</h3>
            <p>{bets.toFixed(2)}</p>
          </div>

          <div className="metric-card" onClick={() => navigate("/admin/casinoHistory")}>
            <h3>Total User Winnings</h3>
            <p>{wins.toFixed(2)}</p>
          </div>

          <div className="metric-card" onClick={() => navigate("/admin/casinoHistory")}>
            <h3>Total Panel Winnings</h3>
            <p>{panelWin.toFixed(2)}</p>
          </div>

          <div className="metric-card">
            <h3>
              Total GGR <span className="change">{ggrpercent}%</span>
            </h3>
            <p>{ggr.toFixed(2)}</p>
          </div>

          {localStorage.getItem("role") === "admin" && (
            <>
              <div className="metric-card">
                <h3>Total Customers</h3>
                <p>{totalCustomer}</p>
              </div>

              <div className="metric-card">
                <h3>Total Agents</h3>
                <p>{totalagent}</p>
              </div>

              <div className="metric-card">
                <h3>Active Customers</h3>
                <p>{activeCustomer}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
